export enum CoreClientAudioApiTags {
  ClientAudio = 'ClientAudio',
}

export const coreClientAudioApiTagTypes = Object.values(CoreClientAudioApiTags);
